import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carAdd"
const CarAddIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.75 17.25H22.875V18.75H18.75V22.875H17.25V18.75H13.125V17.25H17.25V13.125H18.75z" />
          <path
            fillRule="evenodd"
            d="M12 3C14.696 3 16.472 3.385 17.6 3.795 18.164 4 18.564 4.211 18.834 4.381Q19.035 4.51 19.144 4.6 19.198 4.644 19.232 4.674L19.262 4.701 19.276 4.716 19.279 4.718V4.719C19.28 4.721 19.255 4.745 18.844 5.157L19.28 4.72 19.418 4.857 20.388 8.25H22.5V9C22.5 9.78 21.906 10.419 21.146 10.492L21.902 11.625H20.098L19.848 11.25H4.09C3.89 11.504 3.647 11.868 3.419 12.238 3.273 12.474 3.145 12.694 3.053 12.854L3 12.946V18.75H11.625V20.25H5.25C5.25 21.078 4.578 21.75 3.75 21.75H3C2.172 21.75 1.5 21.078 1.5 20.25V12.557L1.593 12.39V12.387L1.597 12.383 1.605 12.368 1.636 12.31 1.752 12.108C1.85 11.937 1.986 11.704 2.142 11.45 2.326 11.154 2.556 10.798 2.79 10.483 2.06 10.381 1.5 9.757 1.5 9V8.25H3.577C3.724 7.728 3.87 7.228 4 6.784 4.152 6.27 4.286 5.832 4.381 5.52L4.493 5.157 4.523 5.06 4.531 5.034 4.534 5.027V5.026L4.59 4.849 4.72 4.72 5.25 5.25 4.72 4.719 4.721 4.718 4.723 4.716 4.74 4.701 4.769 4.674Q4.8 4.644 4.855 4.6 4.965 4.51 5.166 4.38C5.436 4.211 5.836 4.001 6.4 3.795 7.528 3.385 9.304 3 12 3M12 4.5C9.446 4.5 7.847 4.865 6.913 5.205 6.445 5.375 6.143 5.539 5.967 5.65Q5.927 5.677 5.895 5.7L5.815 5.96C5.72 6.268 5.589 6.702 5.439 7.21 5.217 7.96 4.957 8.863 4.719 9.75H19.256L18.097 5.695Q18.068 5.673 18.033 5.65C17.858 5.54 17.555 5.374 17.087 5.205 16.153 4.865 14.554 4.5 12 4.5"
            clipRule="evenodd"
          />
          <path d="M6 14.25C7.243 14.25 8.25 15.257 8.25 16.5H4.5V14.25z" />
        </svg>
      }
    </span>
  )
}
export default CarAddIcon
